export type SvzDialogSizes = 'sm' | 'md' | 'lg' | 'xl';

export const SvzDialogSizesWidth: Record<SvzDialogSizes, string> = {
  sm: '30vw',
  md: '50vw',
  lg: '70vw',
  xl: '90vw',
};
